import { IconCheck, IconRefresh } from "@tabler/icons-react";
import type { EmailInboxRefreshStatusTone } from "../../../hooks/useEmailInboxRefreshFeedback";

interface EmailMailboxRefreshControlProps {
  canSync: boolean;
  isRefreshActive: boolean;
  statusLabel: string;
  showSuccess: boolean;
  statusTone: EmailInboxRefreshStatusTone;
  onRefresh: () => void;
}

function statusLabelClassName(tone: EmailInboxRefreshStatusTone): string {
  switch (tone) {
    case "error":
      return "text-red-600";
    case "success":
      return "text-teal-700";
    case "busy":
      return "text-slate-600";
    default:
      return "text-slate-500";
  }
}

export function EmailMailboxRefreshControl({
  canSync,
  isRefreshActive,
  statusLabel,
  showSuccess,
  statusTone,
  onRefresh,
}: EmailMailboxRefreshControlProps) {
  const showStatus = statusLabel.length > 0;
  const ariaLabel = showStatus ? statusLabel : "Refresh emails";

  return (
    <div className="inline-flex items-center gap-1.5">
      <button
        type="button"
        onClick={onRefresh}
        disabled={!canSync || isRefreshActive}
        aria-label={ariaLabel}
        title={showStatus ? statusLabel : "Sync mailbox"}
        className="inline-flex h-8 w-8 items-center justify-center rounded-md text-slate-600 transition-colors hover:bg-white hover:text-slate-900 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <IconRefresh
          size={16}
          className={isRefreshActive ? "animate-spin" : undefined}
          aria-hidden
        />
      </button>
      {showStatus ? (
        <span
          aria-live="polite"
          className={`inline-flex items-center gap-1 text-sm font-medium ${statusLabelClassName(statusTone)}`}
        >
          {showSuccess ? (
            <IconCheck size={14} className="text-teal-700" aria-hidden />
          ) : null}
          {statusLabel}
        </span>
      ) : null}
    </div>
  );
}
